import React from "react";

import "./HeroSection.css";

export const HeroSection = () => {
  return (
    <>
      <div className="hero-heading-container">
        <h1 className="hero-title">Our Products</h1>
        <h2 className="hero-subtitle">
          Discover the essential tools that will accompany you on your fitness journey.
        </h2>
      </div>
    </>
  );
};
